export enum ProspectTableType {
	Search,
	Nurture,
}

export const SelectableTable = {
	[ProspectTableType.Search]: false,
	[ProspectTableType.Nurture]: true,
};
